<div class="iching-journal__head">
  <div class="iching-journal__heading">
    <h3 class="iching-journal__title">{{ t('humanDesign.iching.journal.title') }}</h3>
    <!-- Exporteren (JSON of Markdown, met uitleg in de dialoog) en importeren (JSON). -->
    <div class="iching-journal__actions">
      <button
        type="button"
        class="iching-journal__action"
        [title]="t('humanDesign.iching.export.buttonTitle')"
        (click)="openExport()"
        data-test-id="iching-journal-export"
      >
        <i class="fas fa-file-export" aria-hidden="true"></i>
        <span>{{ t('humanDesign.iching.export.button') }}</span>
      </button>
      <button
        type="button"
        class="iching-journal__action"
        [title]="t('humanDesign.iching.export.importTitle')"
        (click)="openImport()"
        data-test-id="iching-journal-import"
      >
        <i class="fas fa-file-import" aria-hidden="true"></i>
        <span>{{ t('humanDesign.iching.export.import.button') }}</span>
      </button>
    </div>
  </div>
  <label class="iching-journal__filter">
    <span class="iching-journal__filter-label">{{ t('humanDesign.iching.journal.filterLabel') }}</span>
    <input
      #filterInput
      class="iching-journal__filter-input"
      type="number"
      min="1"
      max="64"
      step="1"
      inputmode="numeric"
      [placeholder]="t('humanDesign.iching.journal.filterPlaceholder')"
      (input)="onFilterInput(filterInput.value)"
      data-test-id="iching-journal-filter"
    />
  </label>
</div>

@if (busy()) {
  <div class="iching-journal__loading" role="status" aria-busy="true"></div>
}

@if (error()) {
  <div class="iching-journal__state" role="alert" data-test-id="iching-journal-error">
    <p class="iching-journal__error">{{ t('humanDesign.iching.journal.loadError') }}</p>
    <button eBtn size="sm" type="button" icon="rotate-right" (click)="load()" data-test-id="iching-journal-retry">
      {{ t('humanDesign.iching.journal.retry') }}
    </button>
  </div>
} @else if (rows().length > 0) {
  <ul class="iching-journal__list" [class.is-stale]="busy()">
    @for (row of rows(); track row.id) {
      <li class="iching-journal__row" data-test-id="iching-journal-row">
        <button type="button" class="iching-journal__open" (click)="open(row)" data-test-id="iching-journal-open">
          <span class="iching-journal__meta">
            <span class="iching-journal__date" data-test-id="iching-journal-date">{{ (row.consultedAt ?? row.createdOn) | dateTimeFormat: 'readableMetricDateAndTime' }}</span>
            @if (row.revisitedOn) {
              <span class="iching-journal__revisited">
                {{ t('humanDesign.iching.journal.revisited', { date: (row.revisitedOn | dateTimeFormat: 'spreadSheetDate') }) }}
              </span>
            }
          </span>
          <span class="iching-journal__question" data-test-id="iching-journal-question" [title]="row.question ?? ''">{{ row.question }}</span>
          <span class="iching-journal__figures">
            <hd-iching-hexagram-figure size="mini" [lines]="parseLines(row.lines)" />
            @if (row.changedHexagram) {
              <span class="iching-journal__arrow" aria-hidden="true">↔</span>
              <hd-iching-hexagram-figure size="mini" [figure]="hexagramBits(row.changedHexagram)" />
            }
            <span class="iching-journal__numbers" data-test-id="iching-journal-numbers">
              #{{ row.primaryHexagram }}
              @if (row.changedHexagram) {
                ↔ #{{ row.changedHexagram }}
              }
            </span>
          </span>
        </button>
        <button
          type="button"
          class="iching-journal__row-action"
          [attr.aria-label]="t('humanDesign.iching.export.buttonEntry')"
          [title]="t('humanDesign.iching.export.buttonEntry')"
          (click)="openExport(row)"
          data-test-id="iching-journal-row-export"
        >
          <i class="fa-regular fa-file-export" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="iching-journal__delete"
          [attr.aria-label]="t('humanDesign.iching.journal.delete')"
          [title]="t('humanDesign.iching.journal.delete')"
          (click)="remove(row)"
          data-test-id="iching-journal-delete"
        >
          <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
        </button>
      </li>
    }
  </ul>
  @if (total() > pageSize) {
    <nav class="iching-journal__pager" [attr.aria-label]="t('humanDesign.iching.journal.pageOf', { page: page(), total: totalPages() })">
      <e-paginator [currentPage]="page()" [pageSize]="pageSize" [totalCount]="total()" (currentPageChange)="setPage($event)"></e-paginator>
    </nav>
  }
} @else if (loaded() && !busy()) {
  <p class="iching-journal__empty" data-test-id="iching-journal-empty">{{ t('humanDesign.iching.journal.empty') }}</p>
}

<e-export-dialog
  [open]="exportTarget() !== undefined"
  (openChange)="onExportOpenChange($event)"
  [title]="exportTitle()"
  [intro]="t('humanDesign.iching.export.intro')"
  [options]="exportOptions()"
  [labels]="exportLabels()"
  [busy]="exporting()"
  (exportRequested)="runExport($event)"
/>

<hd-iching-import-dialog [(open)]="importOpen" (imported)="onImported()" />
